import { render, staticRenderFns } from "./AccountSettingReferrals.vue?vue&type=template&id=bd033ff6&"
import script from "./AccountSettingReferrals.vue?vue&type=script&lang=js&"
export * from "./AccountSettingReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports